import http from './device-orchestrator-gateway-api.http';
import { DeviceOrchestratorGatewayApi } from './device-orchestrator-gateway-api.types';

export default {
  /**
   * Get platform access token for a partner and brand
   * GET /api/v1/partners/{partnerId}/credentials/{brandLowerCase}/access-user
   * @param params - Partner ID and brand (brand will be converted to lowercase)
   * @returns Platform access token
   */
  getPlatformAccessToken: async (
    params: DeviceOrchestratorGatewayApi.GetPlatformAccessTokenParams,
  ): Promise<DeviceOrchestratorGatewayApi.AccessTokenResponse> => {
    const brandLowerCase = params.brand.toLowerCase();
    const { data } = await http.get<DeviceOrchestratorGatewayApi.AccessTokenResponse>(
      `/partners/${params.partnerId}/platforms/${brandLowerCase}/access-token`,
    );
    return data;
  },
};

